import { Controller } from "@hotwired/stimulus"

const SUCCESS_DISPLAY_TIME = 1500
export default class extends Controller {
  async handleInputUpdate(event) {
    const form = event.currentTarget

    try {
      const formData = new FormData(form)
      const response = await fetch(form.dataset.submitPath, {
        method: "PATCH",
        body: formData,
        headers: {
          Accept: "text/vnd.turbo-stream.html",
          "X-CSRF-Token": document.querySelector("meta[name='csrf-token']")?.content,
        },
      })

      if (!response.ok) throw new Error("Update failed")

      form.classList.add("success")
      form.classList.remove("error")
      form.classList.remove("editing")
      setTimeout(() => form.classList.remove("success"), SUCCESS_DISPLAY_TIME)
    } catch (error) {
      form.classList.add("error")
      form.classList.remove("success")
      form.classList.remove("editing")
    }
  }

  async handleInputFocus(event) {
    const form = event.currentTarget
    form.classList.remove("error")
    form.classList.remove("success")
    form.classList.add("editing")
  }
}
